import { lazy } from 'react';
const RebondHor = lazy(() => import('./rebondhor'));

const rebondHorRoutes = [
  {
    path: '/rebondhor',
    component: RebondHor
  }
];

export default rebondHorRoutes;
